var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTagChevron = function SvgIconTagChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.843 4.25a1.74 1.74 0 0 1 1.467.787L22.3 11.03a1.73 1.73 0 0 1 0 1.94l-3.989 5.993a1.74 1.74 0 0 1-1.467.787h-.005l.009-1v1H2.25a1 1 0 0 1-.832-1.554L5.542 12l.094.142.007.01-.007-.01a.27.27 0 0 1 .007-.294l-.007.01-.094.142-4.124-6.196A1 1 0 0 1 2.25 4.25zm0 0h-.005l.009 1v-1zm-.128 2H4.117l3.182 4.78a1.73 1.73 0 0 1 0 1.94l-3.182 4.78h12.598L20.542 12z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTagChevron;